import React, { useEffect, Component } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * ScrollToTop Component
 * Automatically scrolls to top of page on route change
 * Handles both window and main content container scrolling
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    // Scroll main content container to top (primary scroll area)
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }
    // Also scroll window to top (backup)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);
  return null;
}